import createModel, { prop } from './lib/create_model';
import SidePanel, { SidePanelType } from './side_panel';

const AgentLocalState = createModel({
  modelName: 'AgentLocalState',

  properties: {
    answerPanelLastOpenedAt: prop(String).default(''),
    isTaskCommentFormattingOpen: prop(Boolean).default(false),
    shouldCollapseSidebar: prop(Boolean).default(false),
    sidePanel: prop(SidePanel).default(
      () =>
        new SidePanel({
          panelShown: SidePanelType.NONE,
          panelLastShownAt: '',
        })
    ),
  },

  setAnswerPanelLastOpenedAt(lastOpenedAt) {
    this.answerPanelLastOpenedAt = lastOpenedAt;
  },

  setSidePanel(sidePanel) {
    this.sidePanel = sidePanel instanceof SidePanel ? sidePanel : new SidePanel(sidePanel);
  },

  toggleIsTaskCommentFormattingOpen() {
    this.isTaskCommentFormattingOpen = !this.isTaskCommentFormattingOpen;
  },

  toggleShouldCollapseSidebar() {
    this.shouldCollapseSidebar = !this.shouldCollapseSidebar;
  },
});

export default AgentLocalState;
